import { REST } from './utils';

const { GET, POST } = REST('/requestOoOrder');

export const makeRequest = (articleId: string, requestNotes: string): Promise<any> =>
    POST('/submit', { articleId, requestNotes });

export const getRequest = (articleId: string): Promise<any> => GET('/view', { articleId });
